import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
 
function cn(...args) {
  return twMerge(clsx(args));
}

export { cn };